import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class ConteosCiclicos extends Component {
    tableRef = null;
    state = {
        todasConteosCiclicos: [],
        loading: false,
        valor: 1,
    };
    consultarConteosCiclicos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "conteosCiclicos/selectTodasConteosCiclicos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasConteosCiclicos: [] });
                } else {
                    this.setState({
                        todasConteosCiclicos: res.data.data.map(valueConteoCiclico => {
                            return {
                                ...valueConteoCiclico,
                                numero: (valueConteoCiclico.serie ? (valueConteoCiclico.serie + " - ") : "") + (valueConteoCiclico.numero || ""),
                                supervisorNombre: valueConteoCiclico.supervisor ? (
                                    valueConteoCiclico.supervisor.nombre + " " +
                                    valueConteoCiclico.supervisor.apellidoPaterno + " " +
                                    valueConteoCiclico.supervisor.apellidoMaterno
                                ) : "",
                                proyectoNombre: valueConteoCiclico.proyecto ? valueConteoCiclico.proyecto?.nombre : "",
                            }
                        }),
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarConteoCiclico(value) {
        this.setState({ loading: true });
        axios
            .post(
                "conteosCiclicos/deshabilitarConteoCiclico",
                { conteoCiclicoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Conteo cíclico deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarConteoCiclico(value) {
        this.setState({ loading: true });
        axios
            .post(
                "conteosCiclicos/habilitarConteoCiclico",
                { conteoCiclicoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Conteo cíclico habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarConteoCiclico() {
        this.props.history.push('/panel/agregarConteoCiclico')
    }

    editarConteoCiclico(id) {
        this.props.history.push('/panel/editarConteoCiclico', { id })
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "numero",
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Estrategia Selec.",
                dataIndex: "estrategiaSeleccionInsumos",
                key: "estrategiaSeleccionInsumos",
                width: "11%",
                render: (value) => {
                    switch (value) {
                        case 1: return "Más rotación";
                        case 2: return "Menos rotación";
                        case 3: return "Aleatorio (existentes)";
                        case 4: return "Aleatorio (todos)";
                        default: return "—";
                    }
                }
            },
            {
                title: "Modo conteo",
                dataIndex: "modoConteo",
                key: "modoConteo",
                width: "9%",
                render: (value) => {
                    switch (value) {
                        case 1: return "Ciego";
                        case 2: return "Semi-ciego";
                        case 3: return "Abierto";
                        default: return "—";
                    }
                }
            },
            {
                title: "Frecuencia",
                dataIndex: "frecuencia",
                key: "frecuencia",
                width: "9%",
                render: (value) => value || "—",
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                width: "10%",
            },
            {
                title: "Supervisor",
                dataIndex: "supervisorNombre",
                key: "supervisorNombre",
                width: "10%",
            },
            {
                title: "Responsables",
                dataIndex: "responsablesIds",
                key: "responsablesIds",
                width: "6%",
                align: "center",
                render: (value) => Array.isArray(value) ? value.length : 0,
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    buttons.push(
                        <Tooltip
                            title="Editar Conteo Cíclico"
                            placement="top"
                            overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                        >
                            <ButtonItem
                                key={`editar-${record._id}`}
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => this.editarConteoCiclico(record._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    if (record.estado === 1) {
                        buttons.push(
                            <Popconfirm
                                key={`deshabilitar-${record._id}`}
                                title="¿Seguro que quieres deshabilitar este conteo cíclico?"
                                onConfirm={() => this.deshabilitarConteoCiclico(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip
                                    title="Deshabilitar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm
                                key={`habilitar-${record._id}`}
                                title="¿Seguro que quieres habilitar este conteo cíclico?"
                                onConfirm={() => this.habilitarConteoCiclico(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip
                                    title="Habilitar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<StopOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
    },
        ];


    return(
            <>
                <PageHeader
                    title="Conteos Cíclicos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            <ButtonItem
                                type="primary"
                                key="agregarConteoCiclico"
                                onClick={this.agregarConteoCiclico.bind(this)}
                                 className="botonAgregar"
                                 olivo
                            >
                                Agregar Conteo Cíclico
                            </ButtonItem>
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarConteosCiclicos.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasConteosCiclicos}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"conteosCiclicos" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            this.editarConteoCiclico(record.accion._id);
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ConteosCiclicos);
